var _UnsignedInt16_value;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import Exception from '../../Exceptions/Exception';
import { ensureInt } from "./ensureInt";
import Result from '../../Result/Result';
export default class UnsignedInt16 extends Number {
    constructor(value) {
        super(value);
        _UnsignedInt16_value.set(this, void 0);
        ensureInt(value, UnsignedInt16.minValue, UnsignedInt16.maxValue);
        __classPrivateFieldSet(this, _UnsignedInt16_value, value, "f");
    }
    [(_UnsignedInt16_value = new WeakMap(), Symbol.toPrimitive)]() {
        return this.valueOf();
    }
    valueOf() {
        return __classPrivateFieldGet(this, _UnsignedInt16_value, "f").valueOf() & 0xFFFF;
    }
    toString() {
        return this.valueOf().toString();
    }
    static parse(value) {
        const int = parseInt(value);
        return new UnsignedInt16(int);
    }
    static tryParse(value) {
        const int = parseInt(value);
        try {
            ensureInt(int, UnsignedInt16.minValue, UnsignedInt16.maxValue);
            return Result.ok(new UnsignedInt16(int));
        }
        catch (ex) {
            if (ex instanceof Exception) {
                return Result.fail(ex.message);
            }
            else if (ex instanceof Error) {
                return Result.fail(ex.message);
            }
            else {
                return Result.fail(`${ex}`);
            }
        }
    }
}
/** The largest number that can be represented. Equal to 65,535. */
UnsignedInt16.maxValue = 65535;
/** The lowest number that can be represented. Equal to 0. */
UnsignedInt16.minValue = 0;
